"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capacidades = void 0;
var bson_1 = require("bson");
var Capacidades = /** @class */ (function () {
    function Capacidades(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CENTRO_TRAB, CENTRO_TRAB = _c === void 0 ? '' : _c, _d = _a.CENTRO, CENTRO = _d === void 0 ? '' : _d, _e = _a.DT_VAL_INI, DT_VAL_INI = _e === void 0 ? '' : _e, _f = _a.DT_VAL_FIM, DT_VAL_FIM = _f === void 0 ? '' : _f, _g = _a.UN, UN = _g === void 0 ? '' : _g, _h = _a.dataIni, dataIni = _h === void 0 ? new Date() : _h, _j = _a.dataFim, dataFim = _j === void 0 ? new Date() : _j, _k = _a.FABRICA, FABRICA = _k === void 0 ? '' : _k, _l = _a.NO, NO = _l === void 0 ? '' : _l, _m = _a.MINUTOS, MINUTOS = _m === void 0 ? 0 : _m, _o = _a.TIPO_NO, TIPO_NO = _o === void 0 ? '' : _o, _p = _a.DS_TIPO_NO, DS_TIPO_NO = _p === void 0 ? '' : _p, _q = _a.dia, dia = _q === void 0 ? 0 : _q, _r = _a.DATA, DATA = _r === void 0 ? '' : _r, _s = _a.minutosReal, minutosReal = _s === void 0 ? 0 : _s;
        this._id = _id;
        this.CENTRO_TRAB = CENTRO_TRAB;
        this.CENTRO = CENTRO;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.UN = UN;
        this.dataIni = dataIni;
        this.dataFim = dataFim;
        this.FABRICA = FABRICA;
        this.NO = NO;
        this.MINUTOS = MINUTOS;
        this.TIPO_NO = TIPO_NO;
        this.DS_TIPO_NO = DS_TIPO_NO;
        this.dia = dia;
        this.DATA = DATA;
        this.minutosReal = minutosReal;
    }
    return Capacidades;
}());
exports.Capacidades = Capacidades;
//# sourceMappingURL=Capacidades.js.map